import React from 'react';
import SessionsBlob from './SessionsBlob';
import FaIcon from '../../../Elements/FaIcon';

export default function SessionsPane({ sessions, selectedSessionId, onSelect, onNew, q, setQ }) {
  const term = (q || '').trim().toLowerCase();
  const filtered = term
    ? (sessions || []).filter((s) => (s.SessionName || '').toLowerCase().includes(term))
    : sessions || [];

  return (
    <aside className='ac-panel'>
      <div className='ac-phead'>
        <div>
          <div className='eyebrow'>History</div>
          <h2>Conversations</h2>
        </div>
        <div className='sp' />
        <button className='ac-new' onClick={onNew} title='New conversation' aria-label='New conversation'>
          <FaIcon iconName='fa-solid fa-plus' />
        </button>
      </div>
      <div className='ac-searchwrap'>
        <div className='search'>
          <FaIcon iconName='fa-solid fa-magnifying-glass' />
          <input placeholder='Search conversations…' value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
      </div>
      <div className='ac-list'>
        {filtered.map((s) => (
          <SessionsBlob
            key={s.SessionId}
            session={s}
            isSelected={selectedSessionId === s.SessionId}
            onSelect={onSelect}
          />
        ))}
        {filtered.length === 0 ? (
          <div className='ac-emptylist'>
            {term ? `No conversations match “${q}”.` : 'No conversations yet.'}
          </div>
        ) : null}
      </div>
    </aside>
  );
}
